import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Cushion,
  FlexContainer,
  Panel,
  Rectangle,
  ScrollBox,
  Typography,
} from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';
import TokenRedirect from '../token-redirect-link/route';

const ApplyPlayerPanel = ({ isOpen, memberId, onClose, teamNames }) => (
  <Panel isOpen={isOpen} onClose={onClose}>
    <Rectangle fill="seashellgrey" component="div" style={{ height: '100%' }}>
      <ScrollBox yOnly>
        <Cushion horizontal="medium" vertical="xlarge">
          <FlexContainer flexDirection="column" alignItems="center">
            <Cushion vertical="medium">
              <Typography
                align="center"
                preset="subtitle--large"
                color="dustygrey"
                style={{ width: '100%' }}
              >
                <Trans i18nkey="common:availability_not_a_player" values={{ teamNames }}>
                  {`Sorry, you need to be a player for ${teamNames} to attend this session.`}
                </Trans>
              </Typography>
            </Cushion>
            <Button theme="primary">
              <TokenRedirect route="account.membership.roles" params={{ memberId }}>
                <a>
                  <Trans i18nkey="common:manage_roles">Manage your roles</Trans>
                </a>
              </TokenRedirect>
            </Button>
          </FlexContainer>
        </Cushion>
      </ScrollBox>
    </Rectangle>
  </Panel>
);

ApplyPlayerPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  memberId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  teamNames: PropTypes.string.isRequired,
};

export default ApplyPlayerPanel;
